
let  _colors = [
  '#C41E3A', '#FF7F0E', '#FFD700', '#00A36C', '#98FB98',
  '#001F3F', '#0074D9', '#9D50BB', '#6B48FF', '#FF69B4',
  '#FF6B6B', '#556B2F', '#32CD32', '#87CEEB', '#8B0000',
  '#DAA520', '#121212', '#F5F5F5', '#C0C0C0', '#003321'];

export { _colors };